function mergeServices(services) {
    const servicesMap = {};
    services.flat().forEach(service => {
        if (service.treatmentId) {
            const key = service.treatmentId;
            if (!servicesMap[key]) {
                servicesMap[key] = service;
            }
            else {
                servicesMap[key].quantity += service.quantity;
                servicesMap[key].tooths = mergeTeeth([servicesMap[key].tooths, service.tooths]);
                servicesMap[key].duration += service.duration;
            }
        }
        if (service.productId) {
            const key = service.productId;
            if (!servicesMap[key]) {
                servicesMap[key] = service;
            }
            else {
                servicesMap[key].quantity += service.quantity;
            }
        }
    });
    return Object.values(servicesMap);
}
function mergeTeeth(teeths) {
    const resultSet = new Set(teeths.flat());
    return Array.from(resultSet);
}
function mergePayments(payments) {
    const paymentsResult = {};
    payments.flat().forEach(payment => {
        if (paymentsResult[payment.paymentMethod]) {
            paymentsResult[payment.paymentMethod].toPay += payment.toPay;
        }
        else {
            paymentsResult[payment.paymentMethod] = payment;
        }
    });
    return Object.values(paymentsResult);
}
function mergePricings(pricing) {
    return {
        services: pricing.reduce((a, b) => a + b.services, 0),
        products: pricing.reduce((a, b) => a + b.products, 0),
        discount: pricing.reduce((a, b) => a + b.discount, 0),
    };
}
export default function mergeInvoices(invoices) {
    return {
        ...invoices[0],
        services: mergeServices(invoices.map(invoice => invoice.services)),
        payments: mergePayments(invoices.map(invoice => invoice.payments)),
        pricing: mergePricings(invoices.map(invoice => invoice.pricing)),
        totalPrice: invoices.reduce((a, b) => a + b.totalPrice, 0),
        totalPaid: invoices.reduce((a, b) => a + b.totalPaid, 0),
    };
}
